import script from "./EditPerfilView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPerfilView.vue?vue&type=script&setup=true&lang=js"

import "./EditPerfilView.vue?vue&type=style&index=0&id=3fa1fb86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa1fb86"]])

export default __exports__